/*
 * Jira Ticket:
 * Created Date: Thu, 11th Jun 2020, 12:28:56 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getOneTemplateQuery = gql`
  query Template($id: ID!) {
    data: Template(id: $id) {
      id
      name
      variables {
        tag
        description
      }
      content
      ... on EmailTemplate {
        subject
      }
    }
  }
`;
